import React from "react";
import productList from "../../Constants/productList";
import imagesUrls from "../../Constants/imagesUrls";
import "././ProductModal.css";
import "././Navbar.css";

function Products() {
  const products = Object.keys(productList)
    .map((key) => productList[key])
    .flat();

  return (
    <>
      <div className="d-flex justify-content-between">
        <div id="" className="product-dropdown">
          <div className="product-menu-item">
            <ul className="d-flex list-unstyled flex-wrap align-items-end">
              {products.map((filteredProduct, index) => (
                <React.Fragment key={index}>
                  {filteredProduct.category &&
                        filteredProduct.category === "Calculators" ? (
                          <li className="menu-heading m-0 title p-0"></li>
                        ) : (
                          ""
                        )}
                  {filteredProduct.isNavDropdownItem ? (
                    <li className="title" key={index}>
                      {filteredProduct.category &&
                      filteredProduct.isNavDropdownCategory ? (
                        <h6 className="mt-0">{filteredProduct.category}</h6>
                      ) : (
                        ""
                      )}
                      {filteredProduct.isNavDropdownItem ? (
                        <a
                          href={filteredProduct.mobile_url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="icon_ig">
                            <img
                              src={filteredProduct.img_url}
                              alt="fyers-web-icon"
                              className="icon-mobile"
                            />
                          </span>
                          <span>
                            <span className="hover-arrow product-modal-item white_space d-flex">
                              {filteredProduct.name}
                              <img
                                src={imagesUrls.right_arrow_icon}
                                alt="Arrow"
                              />
                            </span>
                            <small className="text-muted">
                              {filteredProduct.description}
                            </small>
                          </span>
                        </a>
                      ) : (
                        ""
                      )}
                    </li>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Products;
